(function ($) {
  $(function () {
    // Funkcja, która sprawdza, czy istnieje element .ag-format-container
    function checkIfElementExists() {
      if ($('.ag-format-container').length) {
        // Element istnieje, wykonaj poniższy kod
        var agTimeline = $('.js-timeline'),
          agTimelineLine = $('.js-timeline_line'),
          agTimelineLineProgress = $('.js-timeline_line-progress'),
          agTimelinePoint = $('.js-timeline-card_point-box'),
          agTimelineItem = $('.js-timeline_item'),
          agOuterHeight = $(window).outerHeight(),
          agHeight = $(window).height(),
          f = -1,
          agFlag = false;

        function fnOnScroll() {
          agPosY = $(window).scrollTop();
          fnUpdateFrame();
        }

        function fnOnResize() {
          agPosY = $(window).scrollTop();
          agHeight = $(window).height();
          fnUpdateFrame();
        }

        function fnUpdateWindow() {
          agFlag = false;

          agTimelineLine.css({
            top: agTimelineItem.first().find(agTimelinePoint).offset().top - agTimelineItem.first().offset().top,
            bottom: agTimeline.offset().top + agTimeline.outerHeight() - agTimelineItem.last().find(agTimelinePoint).offset().top - 10
          });

          f !== agPosY && (f = agPosY, agHeight, fnUpdateProgress());
        }

        function fnUpdateProgress() {
          var agTop = agTimelineItem.last().find(agTimelinePoint).offset().top;

          i = agTop + agPosY - $(window).scrollTop();
          a = agTimelineLineProgress.offset().top + agPosY - $(window).scrollTop();
          n = agPosY - a + agOuterHeight / 2;
          i <= agPosY + agOuterHeight / 2 && (n = i - a);
          agTimelineLineProgress.css({ height: n + "px" });

          agTimelineItem.each(function () {
            var agTop = $(this).find(agTimelinePoint).offset().top;

            (agTop + agPosY - $(window).scrollTop()) < agPosY + 0.5 * agOuterHeight ? $(this).addClass('js-ag-active') : $(this).removeClass('js-ag-active');
          })
        }

        function fnUpdateFrame() {
          agFlag || requestAnimationFrame(fnUpdateWindow);
          agFlag = true;
        }

        // Dodatkowe zdarzenia
        $(window).on('scroll', function () {
          fnOnScroll();
        });

        $(window).on('resize', function () {
          fnOnResize();
        });

        // Inne akcje, które chcesz wykonać w przypadku, gdy element istnieje
      }
    }

    // Wywołanie funkcji sprawdzającej, czy element istnieje
    checkIfElementExists();
  });
})(jQuery);



$(document).ready(function() {
            $("a.list-group-item").click(function(event) {
                event.preventDefault();
                var target = $(this).attr("href");
                var offset = $(target).offset().top;
                $("html, body").animate({scrollTop: offset - 250}); // Możesz dostosować wartość (-100) do preferowanego odstępu od góry bloku
            });
        });